import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import AlbumModuleTypes from '@/store/modules/middleGround/member/album/interface';

const albumModule: Module<AlbumModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        listAlbum(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listAlbum", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        uploadAlbumImg(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/uploadAlbumImg", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteAlbum(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deleteAlbum", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default albumModule;